export const createFileDownload = (file: Blob, filename: string) => {
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(file);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
};
